import { Model } from "@vuex-orm/core";

export default class Downlink extends Model {
  static entity = "downlinks";

  static fields() {
    return {
      id: this.attr(null),
      uplink_interval: this.attr(0),
      downlink_interval: this.attr(0),
      channel: this.attr(15),
      filter: this.attr(0),
      rate: this.attr(0),
      gain: this.attr(0),
      mode: this.attr(0),

      device_id: this.attr(null),
    };
  }
}
